"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _FreeWithCredit = _interopRequireDefault(require("./../FreeWithCredit"));
var _Button = _interopRequireDefault(require("./../Button"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
var DEFINEIMGTYPE = {
  personal: 1,
  personalRight: 11,
  personalRightIcon: 101,
  enterprise: 2,
  enterpriseRight: 12,
  enterpriseRightIcon: 102
};
var DEFINEIMGURL = (_a = {}, _a[DEFINEIMGTYPE.personal] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/jmm4794_red-middle.png', _a[DEFINEIMGTYPE.personalRight] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/Cvk2762_red-right.png', _a[DEFINEIMGTYPE.personalRightIcon] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/ux4v520_red-left.png', _a[DEFINEIMGTYPE.enterprise] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/aiTH489_blue-middle.png', _a[DEFINEIMGTYPE.enterpriseRight] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/8eim788_blue-right.png', _a[DEFINEIMGTYPE.enterpriseRightIcon] = 'https://staticintl.cloudcachetci.com/cms/backend-cms/r7nf649_blue-left.png', _a);
var BuyNowComponent = function BuyNowComponent(props) {
  var flexTitle = props.flexTitle,
    headConfig = props.headConfig,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'free-with-credit-iteration-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'free-with-credit-iteration-container__children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'iteration__head'
  }, /*#__PURE__*/_react["default"].createElement(_FreeWithCredit["default"], {
    flexTitle: flexTitle,
    configuration: headConfig
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'iteration-content'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'iteration-content--container'
  }, configuration.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      buttonConfig = _a.buttonConfig,
      _b = _a.symbol,
      symbol = _b === void 0 ? '$' : _b,
      prompt = _a.prompt,
      price = _a.price,
      agreement = _a.agreement,
      type = _a.type;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: 'iteration-content--container__list'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'iteration-content--container__list__div'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'coupons-class-top'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__title'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'tips-card'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'tips-card__l--img',
      style: {
        background: "url(" + DEFINEIMGURL[Number(type) + 100] + ") no-repeat"
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'tips-card__l--img-level',
      style: {
        background: "url(" + DEFINEIMGURL[type] + ") -16px / 100% 100% no-repeat"
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'tips-card__title'
    }, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'tips-card__r--img',
      style: {
        background: "url(" + DEFINEIMGURL[Number(type) + 10] + ")  no-repeat"
      }
    })), /*#__PURE__*/_react["default"].createElement("ul", {
      className: 'entry-list'
    }, agreement.map(function (items, i) {
      var txt = items.txt;
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: i
      }, /*#__PURE__*/_react["default"].createElement(Svg, null), /*#__PURE__*/_react["default"].createElement("span", null, txt));
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'strong'
    }, prompt || parseInt(price))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'coupons-class'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'bottom-content'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'bottom-content__left'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'pre-symbol'
    }, symbol), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'price'
    }, price)), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'bottom-content__right'
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], __assign({}, buttonConfig || {}))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'circle'
    })));
  })))));
};
function Svg() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05386 8.56078L2.08533 9.57028L6.67967 14.4521L16.4266 4.80963L15.4079 3.76373L6.6133 11.3394L3.05386 8.56078Z",
    fill: "#006EFF"
  }));
}
BuyNowComponent.displayName = 'TCIBuyNowComponent';
var _default = exports["default"] = BuyNowComponent;